import React, {useEffect} from "react";
import PropTypes from 'prop-types';
import {
  SACContainer,
  SACTitle,
  AboutCharity,
  TickMark,
  SuggestedMessage,
  RowFlex,
  DetailsHeading,
  Flex,
  SuggestedContainer,
  HalfWidthContainer,
  DetailsLabel,
  CharityDetailLabels,
  SACvalues,
  ContinueWrapper
} from "../style";
import { FixedWidth,
  EllipsisUnderline,
  EllipsisDataValueWrapper,
  EllipsisContent
} from "../../../../../CommonComponents/commonStyles";
import BreadcrumbComponent from "../../../../../CommonComponents/Breadcrumb/Breadcrumb";
import { ContentMessage, Types } from "../../../../../CommonComponents/ContentMessages";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents"

const SACConfitmationPage = props => {
  useEffect(()=>{
    window.scrollTo(0, 0)
  },[])

  return (
    <SACContainer data-test="contentBlock">
      <FixedWidth>
        <BreadcrumbComponent breadcrumbRoutes={props.breadCrumb()} />
      </FixedWidth>
      <FixedWidth>
        <SACTitle>
          <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Suggest Charity Confirmation" property="field_page_title" defaultMessage="Suggest a charity" />
        </SACTitle>
        <AboutCharity>          
          <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]}  messageId="SACConfirmationMsg" html={true} page="Suggest Charity Confirmation" property="field_header" defaultMessage="<p>Thank you for suggesting a charity. This charity will appear in your saved charities list. Our grants team will use the information you provided to locate the charity. A team member will reach out to you if more information is needed.</p>" />
        </AboutCharity>
        <SuggestedContainer>
          <TickMark />
          <SuggestedMessage>            
            <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} html={true} page="Suggest Charity Confirmation" property="description__value" defaultMessage="<p>Your charity has been suggested.</p>" />
          </SuggestedMessage>
        </SuggestedContainer>
        <RowFlex>
          <HalfWidthContainer>
            <DetailsHeading>Charity Details</DetailsHeading>
            <Flex>
              <CharityDetailLabels>Charity Name </CharityDetailLabels>
              <DetailsLabel>
                <SACvalues>{props.data.cname}</SACvalues>
              </DetailsLabel>
            </Flex>
            {props.data.ein && (
              <Flex>
                <CharityDetailLabels>EIN </CharityDetailLabels>
                <DetailsLabel>
                  <SACvalues>{props.data.ein}</SACvalues>
                </DetailsLabel>
              </Flex>
            )}
            <Flex>
              <CharityDetailLabels>Address </CharityDetailLabels>
              <DetailsLabel>
                <div>
                  <SACvalues>{props.data.addr1},</SACvalues>
                </div>
                {
                  props.data.addr2 && ( 
                  <div>
                    <SACvalues>{props.data.addr2},</SACvalues>
                  </div>)
                }
                {
                  props.data.addr3 && (
                    <div>
                      <SACvalues>{props.data.addr3},</SACvalues>
                    </div>
                  )
                }
                { 
                  props.data.city && props.data.state && props.data.zipcode && (
                  <div>
                    <SACvalues>{props.data.city}, {props.data.state} {props.data.zipcode}</SACvalues>
                  </div>)
                }
                {
                  props.data.countryName && (
                  <div>
                    <SACvalues>{props.data.countryName}</SACvalues>
                  </div>)
                }
              </DetailsLabel>
            </Flex>
          </HalfWidthContainer>
          {
            (props.data.firstName || props.data.lastName ||  props.contactInfo)
            && <HalfWidthContainer>
              <DetailsHeading>Contact Person Details</DetailsHeading>
              {props.data.firstName && (
                <Flex>
                  <DetailsLabel>Contact Name</DetailsLabel>
                  <DetailsLabel>
                    <SACvalues>{props.data.firstName} {props.data.lastName}</SACvalues>
                  </DetailsLabel>
                </Flex>
              )}
              <Flex>
                <DetailsLabel>Charity Contact</DetailsLabel>
                <DetailsLabel>
                  <div>
                    <SACvalues>{props.data.checkContact}</SACvalues>
                  </div>
                  {props.data.contactInfo? (
                    <div>
                      <SACvalues>
                          <EllipsisDataValueWrapper>
                            <EllipsisUnderline>{props.data.contactInfo}</EllipsisUnderline>
                            <EllipsisContent>                           
                              {props.data.contactInfo}
                            </EllipsisContent>
                          </EllipsisDataValueWrapper>
                      </SACvalues>
                    </div>
                  ) : null}
                </DetailsLabel>
              </Flex>
            </HalfWidthContainer>
          }
        </RowFlex>
        <ContinueWrapper>
          <GeneralButton
            id="btnContinue"
            data-test="btnContinue"
            type="functional"
            text="CONTINUE"
            onClick={() => {
              props.clearData();
              props.data.recommandGrant(true);
            }}
            width="177px"
            mobWidth="95%"
          ></GeneralButton>
        </ContinueWrapper>
      </FixedWidth>
    </SACContainer>
  );
};

SACConfitmationPage.propTypes = {
  clearData: PropTypes.func,
  breadCrumb: PropTypes.func,
  data: PropTypes.object
}

export default SACConfitmationPage;
